export * from './ticket-listing.viewmodel';
export * from './ticket.model';
export * from './ticket.parameter';
export * from './ticket-channel-participant.viewmodel';
export * from './ticket-channel-action.viewmodel';
export * from './ticket-channel.viewmodel';
export * from "./ticket-intervention-report.model";


// WEBPACK FOOTER //
// ./src/models/ticket/index.ts